export default __webpack_public_path__ + "static/media/wordmark.186569fc.svg";